
import React, { useState, useEffect, useContext } from 'react';
import Banner from '../component/banner/banner';
import ImportantInfoService from '../service/ImportantInfoService';
import { AuthContext } from './Context';

const BannerProvider = () => {
    const [bannerData, setBannerData] = useState(null);
    const { user } = useContext(AuthContext);

    useEffect(() => {
        const fetchImportantInfos = async () => {
            console.log('User brut dans BannerContext:', user);

            if (!user) {
                console.log('Pas d\'utilisateur connecté');
                return;
            }


            const parsedUser = typeof user === 'string' ? JSON.parse(user) : user;
            console.log('User parsé:', parsedUser);


            const userType = parsedUser.type;
            console.log('Type d\'utilisateur extrait:', userType);

            if (!userType) {
                console.log('Type d\'utilisateur non trouvé');
                return;
            }

            const importantInfos = await ImportantInfoService.getImportantInfos(parsedUser);
            console.log('Informations importantes:', importantInfos);

            if (importantInfos && importantInfos.length > 0) {
                const firstCode = importantInfos[0].code;
                console.log('Code reçu:', firstCode);

                if (userType === "agence_admin") {
                    console.log('Définition du message pour AGENCE_ADMIN');
                    setBannerData({
                        message: "Veuillez compléter le profil Agence",
                        url: "/account"
                    });
                } else if (userType === "admin") {
                    console.log('Définition du message pour COLLABORATEUR');
                    setBannerData({
                        message: "Veuillez compléter votre profil",
                        url: "/account"
                    });
                }
            }
        };

        fetchImportantInfos();
    }, [user]);

    console.log('État actuel du bannerData:', bannerData);

    if (!bannerData) {
        return null;
    }

    return <Banner message={bannerData.message} url={bannerData.url} />;
};

export default BannerProvider;